import api from "../../services/api";

const useRoles = () => {
  const addRole = async (userId, role) => {
    const { data } = await api.post("/role", {
      userId,
      role,
    });
    return data;
  };

  const removeRole = async (userId, role) => {
    const { data } = await api.delete(`/role/${userId}/${role}`);
    return data;
  };

  const getUserRoles = async (userId) => {
    const { data } = await api.get(`/role/${userId}`);
    return data;
  };

  const getAvailableRoles = async () => {
    const { data } = await api.get("/role/list");
    return data;
  };

  return {
    addRole,
    removeRole,
    getUserRoles,
    getAvailableRoles,
  };
};

export default useRoles;
